import { useQuery } from '@tanstack/react-query';
import { ContestApi } from 'api/ApiHelper';
import { contestsQueryKey } from 'queries/contests/queryKey';

export const useGetContestEntriesQuery = (contestId: number, categoryId?: number) =>
  useQuery({
    queryKey: contestsQueryKey.contestContents(contestId, categoryId),
    queryFn: () => ContestApi.getContestEntries(contestId, categoryId),
    enabled: contestId > 0,
  });
